<template>
  <b-form-checkbox v-model="checked" :class="variant" switch @input="onToggle" :disabled="disabled" />
</template>

<script>
  export default {
    props: {
      value: {
        type: Boolean,
        default: true,
      },
      attribute: {
        type: String,
        default: 'visible',
      },
      saveUrl: String,
      disabled: {
        type: Boolean,
        default: false,
      },
      variant: String,
    },
    data() {
      return {
        trans: trans,
        checked: this.value,
      }
    },
    watch: {
      value() {
        this.checked = this.value
      },
    },
    methods: {
      onToggle() {
        this.busy = true
        this.error = null
        let data = {}
        data[this.attribute] = this.checked
        axios.post(this.saveUrl, data)
        .then(response => {
          this.busy = false
          this.$emit('input', this.checked)
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
          _.toastError(this, this.error)
        })
      },
    },
  }
</script>